import { Injectable, inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthorizationService } from '@infodata-group/inf-commons';

@Injectable({
  providedIn: 'root',
})
export class ProfileGuard {
  private auth = inject(AuthorizationService);
  private router = inject(Router);


  canActivate():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const role = this.auth.userContext.role;
    const isAdmin = role === 'A' || role === 'R' || role === 'D';
    if (isAdmin) {
      return true;
    } else {
      this.router.navigateByUrl('403');
    }
  }
}
